const SUPABASE_URL = 'https://jtitgxdptkpnsqhuqavh.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp0aXRneGRwdGtwbnNxaHVxYXZoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODM0NjY1MzksImV4cCI6MjA5OTA0MjUzOX0.DgJkUWXhWngeaWAxpaK4PiC7Ilg1dPIYDiDdbbkjpRQ';
const VISITOR_KEY = 'sc_visitor_id';

function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);

    if (!id) {
      id = `visitor_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }

    return id;
  } catch (e) {
    return `visitor_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  }
}

function getRegionFromCountryCode(countryCode) {
  const code = String(countryCode || '').toUpperCase();

  const gcc = ['QA', 'AE', 'SA', 'KW', 'BH', 'OM'];
  const europe = ['PT', 'ES', 'FR', 'IT', 'DE', 'NL', 'BE', 'DK', 'SE', 'NO', 'FI', 'IE', 'GB', 'CH', 'AT', 'PL', 'CZ', 'GR'];
  const northAmerica = ['US', 'CA'];
  const asia = ['JP', 'KR', 'CN', 'HK', 'SG', 'MY', 'TH', 'ID', 'PH', 'VN'];

  if (gcc.includes(code)) return 'GCC';
  if (europe.includes(code)) return 'Europe';
  if (northAmerica.includes(code)) return 'North America';
  if (asia.includes(code)) return 'Asia';

  return code ? 'Other' : 'Unknown';
}

async function trackProductClick(link) {
  if (!link) return;

  const payload = {
    shopify_product_id: link.dataset.productId || null,
    product_title: link.dataset.productTitle || '',
    product_vendor: link.dataset.productVendor || '',
    product_url: link.dataset.productUrl || '',
    destination_url: link.dataset.destinationUrl || link.href,
    visitor_id: getVisitorId(),
    source_page: window.location.pathname,
    source_url: window.location.href,
    referrer: document.referrer || null,
    country_code: link.dataset.countryCode || null,
    country: link.dataset.countryName || null,
    market_handle: link.dataset.marketHandle || null,
    region: getRegionFromCountryCode(link.dataset.countryCode),
    clicked_at: new Date().toISOString()
  };

  try {
    const response = await fetch(`${SUPABASE_URL}/rest/v1/product_click_events`, {
      method: 'POST',
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
        Prefer: 'return=minimal'
      },
      body: JSON.stringify(payload),
      keepalive: true
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('SC product click insert failed:', errorText);
    }
  } catch (error) {
    console.error('SC product click tracking failed:', error);
  }
}

if (!window.__scProductClickTrackingBound) {
  document.addEventListener('click', function (event) {
    const link = event.target instanceof Element
      ? event.target.closest('[data-sc-product-click]')
      : null;

    if (!link) return;

    trackProductClick(link);
  }, true);

  window.__scProductClickTrackingBound = true;
}